/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../extendIcon';

const Information1 = props => (
  <svg viewBox="0 0 128 128" width="1em" height="1em" {...props}>
    <path d="M63.7 1C29.1 1 1.1 29 1.1 63.6c0 34.5 28 62.6 62.6 62.6 34.5 0 62.6-28 62.6-62.6C126.2 29 98.2 1 63.7 1zm0 119.5c-31.4 0-57-25.6-57-57s25.6-57 57-57 57 25.6 57 57c-.1 31.4-25.7 57-57 57z" />
    <path d="M67.8 51h-15v5.3l6.8 1.1v32.1l-6.8 1.1v5.3h21.7v-5.3l-6.7-1.1zM59.4 31.1h8.2v8.4h-8.2z" />
  </svg>
);

export default extendIcon(Information1);
